import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

import './FormComponent.css'; // 외부 CSS 파일을 import

const RefundView = () => {
    const { rd_seq } = useParams();
    const [refund, setRefund] = useState({});
    const [loading, setLoading] = useState(true);

    const [Message, setMessage] = useState('');
    const [Amt, setAmt] = useState(null);

    useEffect(() => {
        if (rd_seq) {
            const fetchRefundData = async () => {
                try {
                    const successHandler = (response) => {
                        if (response.messageCode === 200) {
                            const { detail } = response.data;
                            //detail
                            setRefund(detail[0]);
                            // setPayment(response.data);
                            setLoading(false);
                        } else {
                            toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
                            setLoading(false);
                        }
                    };

                    const errorHandler = (error) => {
                        toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
                        setLoading(false);
                    };
                    // /admin/detail
                    await request.post(`/refund/admin/detail`, { rd_seq: rd_seq }, successHandler, errorHandler);
                } catch (error) {
                    toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
                    setLoading(false);
                }
            };

            ///admin/userpoint
            fetchRefundData();
        }
    }, [rd_seq]);

    useEffect(() => {
        if (refund.owner_seq) {
            const fetchPointData = async () => {
                try {
                    const successHandler = (response) => {
                        if (response.messageCode === 200) {
                            console.log(response.data);
                        } else {
                        }
                    };

                    const errorHandler = (error) => {};
                    // /admin/detail
                    await request.post(
                        `/points/admin/userpoint`,
                        { owner_seq: refund.owner_seq },
                        successHandler,
                        errorHandler
                    );
                } catch (error) {}
            };

            ///admin/userpoint
            fetchPointData();
        }
    }, [refund]);

    const [selectedOption1, setSelectedOption1] = useState('1'); // 첫 번째 라디오 버튼 그룹의 선택된 값

    const handleOption1Change = (e) => {
        setSelectedOption1(e.target.value); // 첫 번째 라디오 버튼 그룹의 선택된 값을 변경
    };

    const genAmt = (am) => {
        switch (am) {
            case '1':
                return 0;
            case '2':
                return refund.refund_app_amt;
            case '3':
                return Amt;
            default:
                return '환불 오류';
        }
    };

    const setStatus = (text) => {
        switch (text) {
            case '1':
                return 'PAY06';
            case '2':
                return 'PAY04';
            case '3':
                return 'PAY04';
            default:
                return '';
        }
    };

    const handleSubmit = async () => {
        try {
            const message = '환불 후에는 변경이 불가능합니다.\n정말 환불을 진행하시겠습니까?';

            const successHandler = (response) => {
                if (response.messageCode === 200) {
                    console.log(response);
                } else {
                    toast.error('환불 정보를 수정 중 오류가 발생했습니다.');
                }
            };

            const errorHandler = (error) => {
                toast.error('환불 정보를 수정 중 오류가 발생했습니다.');
            };
            // /admin/update
            // owner_seq
            // adjs_points
            // sum_points
            const param = {
                message: Message,
                refund_stat: setStatus(selectedOption1),
                refund_amt: genAmt(selectedOption1),
                rd_seq: rd_seq,
                owner_seq: refund.owner_seq,
                adjs_points: genAmt(selectedOption1),
                point: refund.refund_app_amt,
            };

            if (selectedOption1 === '3' && !Amt) {
                alert('환불 금액을 입력해주세요.');
                return false;
            }
            if (refund.refund_app_amt < Amt) {
                alert('입력하신 금액이 환불 가능 금액보다 높습니다.');
                return false;
            }

            if (window.confirm(message)) {
                // 사용자가 확인을 눌렀을 경우 처리할 로직
                await request.post(`/refund/admin/update`, param, successHandler, errorHandler);
            } else {
                // 사용자가 취소 또는 닫기를 선택했을 경우 처리할 로직
            }
        } catch (error) {
            toast.error('환불 정보를 수정 중 오류가 발생했습니다.');
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <main>
            <h2 className="adm_com_pg_tit">결제 환불신청 &gt; 상세보기</h2>
            <table className="adm_com_board_list type_row">
                <colgroup>
                    <col width="10%" />
                    <col width="40%" />
                    <col width="10%" />
                    <col width="40%" />
                </colgroup>
                <tbody>
                    {/* admin_seq: null
            message: null
            owner_seq: 1
            rd_seq: 1
            refund_amt: null
            refund_app_amt: 95000
            refund_app_dtm: "2024-06-12"
            refund_dtm: null
            refund_stat: "PAY03"
            refund_ty: "point"
            reg_dtm: "2024-06-12"
            user_email: "45584@gmail.com"
            user_seq: 10 */}
                    <tr>
                        <th>환불 요청일</th>
                        <td colSpan={3}>{refund.reg_dtm}</td>
                    </tr>
                    <tr>
                        <th>환불 요청자</th>
                        <td colSpan={3}>{refund.user_email}</td>
                    </tr>
                    <tr>
                        <th>연락처</th>
                        <td colSpan={3}>{'-'}</td>
                    </tr>
                    <tr>
                        <th>포인트 환불 요청금액</th>
                        <td colSpan={3}>{refund.refund_app_amt}</td>
                    </tr>
                    <tr>
                        <th>환불 일</th>
                        <td colSpan={3}>{!refund.refund_dtm ? '-' : refund.refund_dtm}</td>
                    </tr>
                    <tr>
                        <th>환불 상태</th>
                        <td colSpan={3}>{refund.refund_stat}</td>
                    </tr>
                </tbody>
            </table>

            <div className="form-container">
                <div className="form-row">
                    <div className="form-item">
                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="1"
                                    checked={selectedOption1 === '1'}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '1' ? `red` : `black`}`}>
                                    환불불가
                                </div>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="2"
                                    checked={selectedOption1 === '2'}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '2' ? `red` : `black`}`}>
                                    전액환불
                                </div>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="3"
                                    checked={selectedOption1 === '3'}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '3' ? `red` : `black`}`}>
                                    부분환불
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="form-item">
                        <input
                            type="number"
                            placeholder="환불 금액 입력"
                            readOnly={selectedOption1 !== '3' ? true : false}
                            value={Amt}
                            onChange={(e) => setAmt(e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <input
                            type="text"
                            placeholder="메시지 입력"
                            value={Message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <button
                            type="button"
                            className="adm_com_btn blue"
                            disabled={refund.refund_dtm === null ? false : true}
                            onClick={handleSubmit}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>

            <div className="adm_com_btn_wrap bottom center">
                {/* <button className="adm_com_btn blue">취소하기</button> */}
                <Link to="/Refund/History" className="adm_com_btn black">
                    목록
                </Link>
            </div>
            <ToastContainer />
        </main>
    );
};

export default RefundView;
